// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__X8LoC","tabsList":"Tabs_tabsList__97hT2","tabsContainer":"Tabs_tabsContainer__g9YJA"};